<div
  *ngIf="ragBreakdowns"
  class="thinner breakdown-wrapper"
  [app-tooltip]="{
    title: tooltipTitle,
    position: ['bottom'],
    showIcon: false,
    stylingVersion: 3,
    templateRef: breakdownToolTipTemplate
  }"
  [style.width]="displayRelativeValueWidth && maxRAGsSum > 0 ? calculateContainerRelativeWidth() + '%' : '100%'"
>
  <ng-container *ngIf="isEmptyState; else notEmptyState">
    <ng-container *ngIf="displayZeroRAGs">
      <div
        *ngFor="let ragBreakdown of ragBreakdowns; let i = index; trackBy: trackByMethod"
        class="rag-breakdown empty"
        [style.width]="'20%'"
        [style.margin-right]="i < ragBreakdowns.length - 1 ? '2px' : '0px'"
        [class.clickable]="canClickRag"
        (click)="ragClicked(ragBreakdown)"
      >
      <div *ngIf="i < ragBreakdowns.length - 1" class="separator"></div>
      </div>
    </ng-container>
  </ng-container>

  <ng-template #notEmptyState>
    <ng-container *ngFor="let ragBreakdown of ragBreakdowns; let i = index; trackBy: trackByMethod">
      <div
        *ngIf="displayZeroRAGs || ragBreakdown.count > 0"
        class="rag-breakdown"
        [class.skip-zero-values]="!displayZeroRAGs && ragBreakdown.count === 0"
        [style.background-color]="ragBreakdown.colour"
        [style.width]="calculateRelativeWidth(ragBreakdown.count) + '%'"
        [style.margin-right]="i < ragBreakdowns.length - 1 && displayZeroRAGs ? '2px' : '0px'"
        [style.opacity]="getRagOpacity(ragBreakdown)"
        (click)="ragClicked(ragBreakdown)"
        [class.clickable]="canClickRag"
      >
      <div *ngIf="i < ragBreakdowns.length - 1" class="separator"></div>
      </div>
    </ng-container>
  </ng-template>
</div>

<ng-template #breakdownToolTipTemplate>
  <div class="breakdown-tooltip-wrapper">
    <ng-container *ngFor="let ragBreakdown of ragBreakdowns; let i = index; trackBy: trackByMethod">
      <div class="breakdown-tooltip-item">
        <div class="squire" [style.background-color]="ragBreakdown.colour"></div>
        <div class="info">
          <div class="count">{{ ragBreakdown.count }}</div>
          <span class="text">{{ ragBreakdown.text }}</span>
        </div>
      </div>
    </ng-container>
  </div>
</ng-template>
